import { useEffect, useContext } from "react"
import { useFormikContext } from "formik"
import { UserContext } from "../../../context/userContext"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function SupervisionStaffMembership({ field, index }) {
  const formik = useFormikContext()
  const userCtx = useContext(UserContext)
  const form = useContext(FormContext)

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    const currentStaffMembershipId =
      userCtx?.current_staff_membership_id || null

    if (currentStaffMembershipId !== null) {
      formik.setFieldValue(field.field_name, currentStaffMembershipId)
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (formik.values[field.field_name] === "") {
    return (
      <div className={styles.errFieldMsg} style={{ marginBottom: 15 }}>
        No staff has been selected. Staff membership ID not found.
      </div>
    )
  }

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
